import { Controller } from "@hotwired/stimulus"
import { IANAToRailsTimezone } from "web/services/railsTimeZone"

export default class BrowserTimeZoneController extends Controller {
  connect() {
    const timeZone = IANAToRailsTimezone(
      Intl.DateTimeFormat().resolvedOptions().timeZone
    )

    if (timeZone) this.element.value = timeZone
  }
}
